import { Routes, Route } from 'react-router-dom'
import { Loading } from '@fedsim/components'
import { routesList } from 'constants/routes'
import React, { Suspense } from 'react'

import Landing from './landing';

const QuickMode = React.lazy(() => import('pages/quick-mode'))
const Tournaments = React.lazy(() => import('pages/tournaments'))
const Ratings = React.lazy(() => import('pages/ratings'))
const Draft = React.lazy(() => import('pages/draft'))
const Arenas = React.lazy(() => import('pages/arenas'))
const Dashboard = React.lazy(() => import('pages/dashboard'))
const Dialog = React.lazy(() => import('pages/dialog'))
// const Dev = React.lazy(() => import('pages/dev'))
const Import = React.lazy(() => import('pages/import'))
const Vault = React.lazy(() => import('pages/vault'))
const Rumbles = React.lazy(() => import('pages/rumbles'))
const Cards = React.lazy(() => import('components/memory'))
const Leagues = React.lazy(() => import('pages/leagues/index'))
const Reigns = React.lazy(() => import('pages/planner/reigns'))
const Repoint = React.lazy(() => import('pages/repoint'))
const Feuds = React.lazy(() => import('pages/feuds'))
const FeudsPlanner = React.lazy(() => import('pages/planner/feuds'))
const Production = React.lazy(() => import('pages/production'))
const Help = React.lazy(() => import('pages/help'))
const Alignment = React.lazy(() => import('pages/alignment/'))
const Simulate = React.lazy(() => import('pages/simulate/'))
const DS = React.lazy(() => import('pages/ds'))
const Settings = React.lazy(() => import('pages/settings/'))
const Match = React.lazy(() => import('pages/match'))
const Office = React.lazy(() => import('pages/office'))
const SetUp = React.lazy(() => import('pages/setup'))
const Blog = React.lazy(() => import('pages/blog'))
const Migrations = React.lazy(() => import('pages/migrations'))

const CreateShow = React.lazy(() => import('pages/create-show'))
const Brands = React.lazy(() => import('pages/brands/index'))

const Backstage = React.lazy(() => import('pages/backstage/index'))

export default function AppRoutes() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path={'/'} index element={<Landing />} />
        <Route path={'/vault'} element={<Vault />} />
        <Route path={'/ratings'} element={<Ratings />} />
        <Route path={'/tournaments'} element={<Tournaments />} />
        <Route path={'/repoint'} element={<Repoint />} />
        <Route path={routesList.QUICKMODE.path} element={<QuickMode />} />
        <Route path={routesList.DRAFT.path} element={<Draft />} />
        <Route path={routesList.BACKSTAGE.path} element={<Backstage />} />
        <Route path={routesList.SIMULATE.path} element={<Simulate />} />
        <Route path={routesList.HELP.path} element={<Help />} />
        <Route path={routesList.DASHBOARD.path} element={<Dashboard />} />
        <Route path={routesList.DIALOG.path} element={<Dialog />} />
        <Route path={routesList.ARENAS.path} element={<Arenas />} />
        <Route path={routesList.RUMBLES.path} element={<Rumbles />} />
        <Route path={routesList.BRANDS.path} element={<Brands />} />
        <Route path={routesList.DEFAULT.path} element={<Dashboard />} />
        <Route path={routesList.CARDS.path} element={<Cards />} />
        <Route path={routesList.IMPORT.path} element={<Import />} />
        <Route path={routesList.MATCH.path} element={<Match />} />
        <Route path={routesList.OFFICE.path} element={<Office />} />
        <Route path={routesList.CREATE_SHOW.path} element={<CreateShow />} />
        <Route path={routesList.PRODUCTION.path} element={<Production />} />
        <Route path={routesList.ALIGNMENT.path} element={<Alignment />} />
        <Route path={routesList.LEAGUES.path} element={<Leagues />} />
        <Route path={routesList.REIGNS.path} element={<Reigns />} />
        <Route path={routesList.FEUDS.path} element={<Feuds />} />
        <Route path={routesList.FEUDS_PLANNER.path} element={<FeudsPlanner />} />
        <Route path={routesList.BLOG.path} element={<Blog />} />
        <Route path={routesList.MIGRATIONS.path} element={<Migrations />} />
        <Route path={routesList.SETTINGS.path} element={<Settings />} />
        <Route path={routesList.DS.path} element={<DS />} />
        <Route path={routesList.SETUP.path} element={<SetUp />} />
      </Routes>
    </Suspense>
  )
}
